import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";
import { Button, Icon } from "@wordpress/components";
import { useSelect, useDispatch } from "@wordpress/data";
import { t } from "drupal";
import AccordionContainerSidePanel from "./sidePanel";
import { useEffect, useRef } from "@wordpress/element";
import { createBlock } from '@wordpress/blocks';
import { debug } from '../utilities/helpers';



function Edit({ attributes, setAttributes, clientId }) {
  const { accordionId, backgroundColorClass = "" } = attributes;

  const { insertBlock } = useDispatch('core/block-editor');

  const addAccordionItem = () => {
    if (!accordionId) {
      console.warn("Accordion ID not ready yet.");
      return;
    }

    const newItem = wp.blocks.createBlock('deohs-gutenberg-blocks/deohs-accordion-item', {
      backgroundColorClass: backgroundColorClass,
      accordionId: accordionId,
      isOpen: true,
    });

    insertBlock(newItem, undefined, clientId).then((blockId) => {
      if (blockId) {
        wp.data.dispatch('core/block-editor').selectBlock(blockId);
      }
    });
  };


  const onChangeBackgroundColorClass = (className) =>
    setAttributes({ backgroundColorClass: className });


  const { updateBlockAttributes } = useDispatch('core/block-editor');

  const innerBlocks = useSelect(
    (select) => select('core/block-editor').getBlock(clientId)?.innerBlocks || [],
    [clientId]
  );

  const previousBackgroundColorRef = useRef();


  const ALLOWED_BLOCKS = [
    "deohs-gutenberg-blocks/deohs-accordion-item",
  ];

  // After accordionId is set
  const TEMPLATE = accordionId ? [
    [
      "deohs-gutenberg-blocks/deohs-accordion-item",
      {
        backgroundColorClass: backgroundColorClass,
        accordionId: accordionId,
      }
    ]
  ] : [];


  useEffect(() => {
    const newId = `accordion-${clientId}`;
    console.log("*** Setting accordionId: ***", newId);
    if (accordionId !== newId) {
      setAttributes({ accordionId: newId });
    }
  }, [clientId]);

  // Update background color of child accordion-items when parent backgroundColorClass changes
  useEffect(() => {
    if (backgroundColorClass) {
      innerBlocks.forEach((block) => {
        const currentColor = block.attributes?.backgroundColorClass;

        const wasSetByParent =
          !currentColor ||
          currentColor === '' ||
          currentColor === previousBackgroundColorRef.current;

        if (wasSetByParent || block.attributes.accordionId !== accordionId) {
          updateBlockAttributes(block.clientId, {
            backgroundColorClass: backgroundColorClass,
            accordionId: accordionId,
          });
        }

      });

      // Update the previous value
      previousBackgroundColorRef.current = backgroundColorClass;
    }

  }, [backgroundColorClass, accordionId, innerBlocks, updateBlockAttributes]);

  // debug("Accordion Parent - Edit", { backgroundColorClass, accordionId });


  const blockProps = useBlockProps({ className: `accordion accordion-flush ${backgroundColorClass}` });


  if (!accordionId) {
    return null; // or a loading spinner if desired
  }


  return (
    <>

      <div {...blockProps} id={accordionId}>
        <InnerBlocks
          allowedBlocks={ALLOWED_BLOCKS}
          template={TEMPLATE}
          templateLock={false}
          renderAppender={false}
        />
      </div>

      {/* Add button outside accordion */}
      <div className="accordion-add-container">
        <Button
          onClick={addAccordionItem}
          className="accordion-add"
          // disabled={!clientId}
          disabled={!accordionId}
        >

          <Icon icon="plus" /> {t("Add Another Accordion")}
        </Button>
      </div>
      <AccordionContainerSidePanel
        attributes={attributes}
        setAttributes={setAttributes}
        />
    </>
  );
}

export default Edit;
